/** Engine app Settings accessor wrapping shared configuration with runtime overrides. */
import { GetClientIP } from './Helpers';
import { GetSharedSettings, Logger } from '@shared/common';

/** File-local constants for Settings. */
const localConstants = { logContext: 'Settings' } as const;

// Must access env variables here to activate VITE bindings (logs only in development builds). Guard the access: outside Vite (e.g. tsx running build-hashes, which imports this module transitively),
// `import.meta.env` is undefined, and an unguarded read crashes the importer — silently zeroing the localization hash artifacts and disabling the translate gate.
Logger.Debug(localConstants.logContext, 'Frontend Settings module initialized.');
Logger.Debug(localConstants.logContext, `VITE_ENV_MODE: ${(import.meta as any)?.env?.VITE_ENV_MODE}`);

/** Environment variables from import.meta.env. */
const env = (() => (import.meta as any)?.env || {})();

/**
 * Application settings accessor.
 *
 * - Wraps the shared Settings to provide environment-specific configuration.
 * - In Development mode, uses the actual client IP from window.location.hostname for network access.
 *
 * `skipContainers` is intentionally empty: `devOverridesMap` now only scopes BACKEND service URI overrides, which the browser never reads. Frontend (apps/sessions) URIs stay canonical across all
 * runtime modes — `launch.ts` writes nginx proxy blocks in the assets container so the same `localhost:${ASSETS_PORT}/web/<area>/<name>` URL transparently routes either to the baked static SPA
 * or to a host-bound vite dev server when that frontend is self-launched.
 */
export const Settings = GetSharedSettings(env.VITE_ENV_MODE, [], GetClientIP());
